import styled from 'styled-components';

// Question
export const Box = styled.div`
  max-width: 40rem;
  margin: auto;
  border-style: dashed;
  border-width: 2px;
`;

export const VoiceIndicator = styled.div`
  width: 80px;
  display: flex;
  justify-content: center;
  padding: 1rem;
  border-left: 2px dashed #e5e7eb;
`;
